// extracted by mini-css-extract-plugin
module.exports = {"group":"_3RgY4yu","title":"_285RXLc"};